import { Grid } from '@mui/material'
import React from 'react'

export function ResponsiveGrid({children}: React.PropsWithChildren<{}>) {
  return (
    <Grid container spacing={3}>
      { children }
    </Grid>
  )
}

export function ResponsiveGridItem({children}: React.PropsWithChildren<{}>) {
  return (
    <Grid item xs={12} lg={6}>
        { children }
    </Grid>
  )
}